import { RootState } from '../../app/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Organization } from '../../types';

const initialSelectedOrgState: Organization = {
    id: '',
    name: '',
};

export type OrgFlow = {
    flow: string;
    isOpen: boolean;
    type?: string;
    realmPayload?: {
        realmId: string;
        realmName?: string;
        realmPrefix?: string;
        level?: number;
    };
};

const orgSlice = createSlice({
    name: 'org',
    initialState: {
        isOrgInvalidated: false,
        selectedOrg: initialSelectedOrgState,
        switchOrgModal: false,
        orgFlowModal: { isOpen: false, flow: '' },
        deleteOrgModal: { isOpen: false, org: undefined },
    } as any,
    reducers: {
        setAddRealmModal: (state: RootState, action: PayloadAction<any>) => {
            state.addRealmModal = action.payload;
        },
        setSelectedOrg: (state, action: PayloadAction<any>) => {
            state.selectedOrg = action.payload;
        },
        switchOrgModal: (state, { payload }: PayloadAction<boolean>) => {
            state.switchOrgModal = payload;
        },
        setDeleteOrgModal: (
            state,
            { payload }: PayloadAction<{ isOpen: boolean; org: any; shouldInvalidateAfterSuccess?: boolean }>
        ) => {
            state.deleteOrgModal = payload;
        },
        orgFlowModal: (state, { payload }: PayloadAction<any>) => {
            state.orgFlowModal = payload;
        },
        setIsOrgInvalidated: (state, { payload }: PayloadAction<any>) => {
            state.isOrgInvalidated = payload;
        },
    },
});

export const {
    setAddRealmModal,
    setSelectedOrg,
    orgFlowModal,
    switchOrgModal,
    setDeleteOrgModal,
    setIsOrgInvalidated,
} = orgSlice.actions;
export const selectOrgFlowModal = (state: RootState): OrgFlow => state.org.orgFlowModal;
export const selectedOrg = (state: RootState): Organization => state.org.selectedOrg;
export const deleteOrgModal = (state: RootState): any => state.org.deleteOrgModal;
export const selectSwitchOrgModal = (state: RootState): boolean => state.org.switchOrgModal;

export default orgSlice;
